export const MAXIMUM_STORYBOARD_VIDEO_DURATION = 10 * 60;
// TODO make more accurate/dynamic with backend
export const SPEECH_WORDS_PER_MINUTE = 130;
export const ENABLE_MP3_ENCODING = false; // enable/disable MP3 encoding
export enum VOICES_PROVIDERS {
  ELEVEN_LABS = "high_quality_01",
}

export const DESKTOP_ASPECT_RATIO = 16 / 9;
export const MOBILE_ASPECT_RATIO = 9 / 16;
export const TABLET_ASPECT_RATIO = 3 / 4;
// like backend ratio 1080p or 720p for generated videos
export const DEFAULT_MEDIA_VIDEO_ASPECT_RATIO = MOBILE_ASPECT_RATIO;

export const MEDIA_HEGHT_BY_ASPECT_RATIO = {
  [MOBILE_ASPECT_RATIO]: 1920,
  [TABLET_ASPECT_RATIO]: 2048,
  [DESKTOP_ASPECT_RATIO]: 1080,
};

export const CHAT_HISTORY_PAGE_SIZE = 10;
export const ACTIVITY_TIMELINE_PAGE_SIZE = 20;
export const HG_EDITOR_SCRIPT_URL = import.meta.env.VITE_HG_EDITOR_SCRIPT_URL;

// Asset URL refresh timings (for S3 signed URLs that typically expire in ~30 minutes)
export const ASSET_REFRESH_INTERVAL = 28 * 60 * 1000; // 28 minutes - refresh before expiration
export const ASSET_STALE_TIME = 25 * 60 * 1000; // 25 minutes - allows React Query to refetch

export const DEFAULT_ANALYTICS_DATE_RANGE = "30D";
export const DEFAULT_ANALYTICS_DATE_RANGE_DAYS = 29; // subtract 29 to get 30 days including today
